// @flow
import { decorate, observable, action } from 'mobx';
import type { User } from 'gwu';
import Api from '../../api';

class AdminStore {
  userForEdit: User | null = null;
  isFetchingUserForEdit: boolean;
  isUpdatingUserRights: boolean;

  async fetchUserForEdit(username: string) {
    try {
      this.isFetchingUserForEdit = true;
      const { data } = await Api.getUserRights(username);
      this.userForEdit = data;
      this.isFetchingUserForEdit = false;
    } catch (e) {
      // TODO handle 403 errors
      this.isFetchingUserForEdit = false;
    }
  }

  async updateUserRights(username: string, rights: Object) {
    try {
      this.isUpdatingUserRights = true;
      const { data } = await Api.updateUserRights(username, rights);
      this.userForEdit = data;
      this.isUpdatingUserRights = false;
    } catch (e) {
      // TODO handle 403 errors
      this.isUpdatingUserRights = false;
    }
  }

  clearUserForEdit() {
    this.userForEdit = null;
  }
}

decorate(AdminStore, {
  userForEdit: observable,
  isFetchingUserForEdit: observable,
  isUpdatingUserRights: observable,
  fetchUserForEdit: action,
  updateUserRights: action,
  clearUserForEdit: action
});

export default new AdminStore();



// WEBPACK FOOTER //
// ./src/modules/admin/AdminStore.js